import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import config from 'utils/constants/config';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root';
import { initSentry } from './sentry';

initSentry(config.SENTRY_DSN);

ReactDOM.render(<Root />, document.getElementById('root'));
